export default __webpack_public_path__ + "static/media/ch.6cd9ab65.jpeg";